/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Civil_Engineering21Inputs */

const en__field_enum_icsrm_civil_engineering21 = /** @type {(inputs: _Field_Enum_Icsrm_Civil_Engineering21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Civil & Environmental Engineering`)
};

const de__field_enum_icsrm_civil_engineering21 = /** @type {(inputs: _Field_Enum_Icsrm_Civil_Engineering21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bau- & Umweltingenierwissenschaften`)
};

/**
* | output |
* | --- |
* | "Civil & Environmental Engineering" |
*
* @param {_Field_Enum_Icsrm_Civil_Engineering21Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_civil_engineering21 = /** @type {((inputs?: _Field_Enum_Icsrm_Civil_Engineering21Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Civil_Engineering21Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_civil_engineering21(inputs)
	return de__field_enum_icsrm_civil_engineering21(inputs)
});
export { _field_enum_icsrm_civil_engineering21 as "_field_enum_ICSRM_CIVIL_ENGINEERING" }